/**
 * AuthGate — top-level route gate.
 *
 * Renders:
 *   - a full-screen loading state while auth is initializing
 *   - AuthScreen if no session
 *   - the wrapped app (FounderConsole) if authenticated
 *
 * This is the single place in the app that decides "should the console
 * even render". Downstream components can safely assume `useAuth().user`
 * is populated.
 */
import { useAuth } from "@/auth/AuthProvider";
import AuthScreen from "@/auth/AuthScreen";

export default function AuthGate({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div
                data-testid="auth-gate-loading"
                className="min-h-screen w-full flex items-center justify-center bg-qoryn-bg"
            >
                <span className="font-mono-ui text-[10px] tracking-widest uppercase text-qoryn-textDim">
                    signing in…
                </span>
            </div>
        );
    }
    if (!user) return <AuthScreen />;
    return children;
}
